<template id="Suivi">
	<div>
		<div class="page">
			<div v-if="!show_suivi||!this.$store.state.vehicule.completed" class="form_command fade-in fade-out">
				<p v-if="facture.error" class="error_txt">{{this.facture.txt}}</p>
				<p v-if="naissance.error" class="error_txt">{{this.naissance.txt}}</p>
				<p v-if="immat.error" class="error_txt">{{this.immat.txt}}</p>
				<p v-if="mail.error" class="error_txt">{{this.mail.txt}}</p>
				<p v-if="dossier.error!=''" class="error_txt">{{this.dossier.error}}</p>
				<div class="inputs">
					<div class="inputs1">
						<div class=input>
							<label for="facture" class="label">N° de Facture</label>
							<input v-model="facture.value" id="facture" name="facture" type="text" class="simu-input immat-imput" v-bind:class="{error_input:facture.error}">
						</div>
						<div class=input>
							<label for="naissance" class="label">Date de Naissance</label>
							<input v-model="naissance.value" id="naissance" name="naissance" type="date" class="simu-input immat-imput" v-bind:class="{error_input:naissance.error}">
						</div>
						<div class=input>
							<label for="immat" class="label">Numéro d'immatriculation'</label>
							<input v-model="immat.value" id="immat" name="immat" type="tel" minlength="10" maxlength="12" class="simu-input error-input" v-bind:class="{error_input:immat.error}" placeholder="AA-123-BB">
						</div>
						<div class=input>
							<label for="mail" class="label">Adresse mail</label>
							<input v-model="mail.value" id="mail" name="mail" type="text" class="simu-input immat-imput" v-bind:class="{error_input:mail.error}">
						</div>
					</div>
				</div>
			</div>
			<div v-if="!show_suivi||!this.$store.state.vehicule.completed" class="btn_command_div">
				<button  @click="go()" class="btn_command fade-in fade-out">Accéder à mon dossier</button>
			</div>
			<div v-if="show_suivi&&this.$store.state.vehicule.completed" class="suivi">
				<div class="suivi_vehicule">
					<Vehicule class="component" id="Go"/>
				</div>
				<div class="suivi_infos">
					<h3>Demande : {{this.$store.state.vehicule.demarche.txt}}</h3>
					<h3>{{dossier.prix}}€ payés le {{dossier.date}}</h3>
					<h3>Statut du dossier : {{dossier.statut}}</h3>
				</div>
			</div>
				<div v-if="show_suivi&&this.$store.state.vehicule.completed" class="suivi_options">
					<div class="options">
						<div class="option">
							<h2>Option n° 1 :</h2>
							<h4>Nous envoyer votre dossier complet directement par courrier.<br><br>Les documents suivants doivent impérativement être envoyés en originaux :<br>- Carte Grise<br>- Certificat de cession<br><br>Les autres documents doivent être des photocopies de bonne qualité</h4>
						</div>
						<div class="option">
							<h2>Option n° 2 (recommandée) :</h2>
							<h4>Nous pré-envoyer numériquement votre dossier. En fonction de sa complétude et de la qualité des pièces, nous vous communiquerons, si nécessaire, les documents à nous envoyer par courrier</h4>
						</div>
					</div>
					
				<h3 class="pieces">Pour connaître la liste des pièces à fournir en fonction de votre situation, rendez vous sur <router-link :to="$store.state.vehicule.demarche.path" target="_blank" class="router">cette page.</router-link></h3>
<!-- 				<a :href="mandat.loc" download>Télécharger le formulaire obligatoire "Mandat d'immatriculation"</a>
				<a :href="dci.loc" download>Télécharger le formulaire obligatoire "Demande de certificat d'immatriculation"</a>
				<a :href="perte.loc" download>Télécharger le formulaire "Déclaration de perte" (pour les demandes de duplicata)</a> -->
				<div class="options">
						<div class="option">
				<h2>Adresse postale pour l'envoi des dossiers papiers :</h2>
				<h4>50 Avenue de Montpellier<br>34770 Gigean<br><br>Il est très fortement conseillé d'envoyer vos document en lettre suivi ou en lettre recommandée</h4>
				</div>
				<div class="option">
					<h2>Adresse mail pour l'envoi des documents numériquement</h2>
					<h4>gigean@lesrelaiscartegrise.fr<br><br>Veuillez préciser au minimum le numéro d'immatriculation dans l'objet du mail</h4>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	const fb = require('../../firebaseConfig.js')
	import Vehicule from '../Vehicule.vue'
	import firebase from 'firebase'
export default {
	components:{Vehicule},
	name: 'Suivi',
	data () {
		return {
			// mandat:{loc:require('../../assets/files/mandat.pdf')},
			// dci:{loc:require('../../assets/files/dci.pdf')},
			// perte:{loc:require('../../assets/files/declaration_perte.pdf')},
			facture:{
				value:"",
				error:false,
				txt:""
			},
			immat:{
				value:"",
				error:false,
				txt:""
			},
			mail:{
				value:"",
				error:false,
				txt:""
			},
			naissance:{
				value:"",
				error:false,
				txt:""
			},
			dossier:{
				statut:"",
				error:"",
				prix:"",
				date:""
			},
			show_suivi:false,
			link:""
		}
	},
	methods: {
		control_inputs(){
			var re_mail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
			var re_facture = /^\d{5}$/;
			var errors = [];
			var result = true;
			if(!re_facture.test(this.facture.value)){
				errors.push("facture");
			}
			if(!re_mail.test(this.mail.value)){
				errors.push("mail");		
			}
			return {errors:errors};
		},
		test_immat(){
			var test_immat = this.immat.value.toUpperCase().split("-").join("").split(" ").join("");
			var re_old = /^[0-9]{1,4}[A-Z]{2,3}[0-9]{2}$/
			var re_new = /^[A-Z]{2}[0-9]{3}[A-Z]{2}$/
			if(re_old.test(test_immat)){
				var new_immat = test_immat.split("");
				var type = "number";
				var new_immat2 = "";
				new_immat.forEach((str,i,arr)=>{
					if(isNaN(str)){
						if(type=='number'){
							new_immat2 += "-";
							new_immat2 += str;
							type = "string";
						}else{
							new_immat2 += str;
						}
					}else{
						if(type=="string"){
							new_immat2 += "-";
							new_immat2 += str;
							type = "number";
						}else{
							new_immat2 += str;
						}
					}
				});
				this.immat.value=new_immat2;
				return {result:true,type_immat:"fni"}
			}else if(re_new.test(test_immat)){
				var new_immat = test_immat.split("");
				var new_immat2 = new_immat[0]+new_immat[1]+"-"+new_immat[2]+new_immat[3]+new_immat[4]+"-"+new_immat[5]+new_immat[6];
				this.immat.value=new_immat2
				return {result:true,type_immat:"siv"}
			}else{
				return {result:false}
			}
		},
		go(){
			var go = true;
			var control_inputs = this.control_inputs();
			if(this.naissance.value == ""){
				this.naissance.error=true;
				this.naissance.txt="Veuillez saisir votre date de naissance";
				go=false;
			}else{
				this.naissance.error=false;
			}
			if(this.facture.value == ""){
				this.facture.error=true;
				this.facture.txt="Veuillez saisir votre numéro de facture";
				go=false;
			}else{
				if(control_inputs.errors.includes("facture")){
					this.facture.error=true;
					this.facture.txt="Veuillez saisir un numéro de facture correct (5 chiffres)";
					go=false;
				}else{
					this.facture.error=false;
				}
			}
			if(this.mail.value == ""){
				this.mail.error=true;
				this.mail.txt="Veuillez saisir votre adresse mail";
				go=false;
			}else{
				if(control_inputs.errors.includes("mail")){
					this.mail.error=true;
					this.mail.txt="Veuillez saisir une adresse mail correcte";
					go=false;
				}else{
					this.mail.error=false;
				}
			}
			if(this.immat.value == ""){
				//console.log("immat emply");
				this.immat.error=true;
				this.immat.txt="Veuillez saisir un numéro d'immatriculation.";
				go=false;
			}else{
				this.immat.error=false;
			}
			var test_immat = this.test_immat();
			if(test_immat.result){
				this.immat.error=false;
			}else{
				this.immat.error=true;
				this.immat.txt="Veuillez saisir un numéro d'immatriculation valide (au format AA-123-BB (SIV) ou 1-AA-22 ou 11-AAA-22 ... (FNI).";
				go=false;
			}
			if(go){
				firebase.auth().signInAnonymously()
      			.then(() => {
					fb.db.collection('suivi_site_web').doc(this.facture.value).get().then(dossier_ => {
	        			if(dossier_.exists){
	        				var dossier = dossier_.data();
	        				this.dossier.statut=dossier.statut_dossier;
	        				//console.log(dossier)
	        				if(this.immat.value==dossier.immat&&this.naissance.value==dossier.naissance&&this.mail.value==dossier.email){
	        					fb.db.collection('paiements').doc(dossier.paiement_id).get().then(paiement_ => {
	        						var paiement = paiement_.data();
	        						this.dossier.prix=paiement.prixTotal;
	        						// var formated_date = paiement.date.toDate().getDay()+"/"+paiement.date.toDate().getMonth()+"/"+paiement.date.toDate().getFullYear();
	        						var formated_date = new Date(paiement.date.seconds*1000 + paiement.date.nanoseconds/1000000).toLocaleDateString('fr');
	        						this.dossier.date=formated_date;
	        						//console.log(paiement)
	        						fb.db.collection('immatriculations').doc(this.immat.value).get().then(vehicule_ => {
		        						var vehicule = vehicule_.data();
		        						//console.log(vehicule);
		        						this.$store.commit("addVehiculeInfos",{
											immat:this.immat.value,
								            type_immat:test_immat.type_immat,
								            dpt:paiement.cp.split("")[0]+paiement.cp.split("")[1],
								            demarche:paiement.demarche.value,
								            immat_content:vehicule.content
								          });
		        						this.show_suivi=true
	        						}).catch(error=>{
	        							this.dossier.error="Votre dossier n'a pas pu être retrouvé. Veuillez vérifier les informations. Si le problème persiste, contactez-nous."
	        							//console.log(error)
	        						});
	        					}).catch(error=>{
	        						this.dossier.error="Votre dossier n'a pas pu être retrouvé. Veuillez vérifier les informations. Si le problème persiste, contactez-nous."
	        						//console.log(error)
	        					});
	        				}else{
	        					this.dossier.error="Votre dossier n'a pas pu être retrouvé. Veuillez vérifier les informations. Si le problème persiste, contactez-nous."
	        				}
	        			}else{
	        				this.dossier.error="Votre dossier n'a pas pu être retrouvé. Veuillez vérifier les informations. Si le problème persiste, contactez-nous."
	        			}
	        		});
	        	});
				//console.log("go");
			}else{
				//console.log("not go");
			}
		}
	},
	mounted () {
		if(this.$route.query.facture){
			this.facture.value=this.$route.query.facture;
		}
	},
	destroyed () {
		this.$store.commit('cleanVehicule');
	}
}
</script>

<style scoped>
	h1{
		color: black;
	}
	h2{
		text-align:center;
		font-weight:400;
		font-size: 1.4em;
	}
	.suivi{
		padding: 20px;
	}
	.suivi_vehicule{
		display:flex;
		justify-content:center;
	}
	.suivi_infos{
		background-color:#fbfbfb;
		border-radius:5px;
		padding:20px 40px 20px 40px;
		margin-top: 40px;
		text-align:center;
	}
	.suivi_options{
		background-color:#fbfbfb;
		border-radius:5px;
		padding:30px 35px 30px 35px;
		margin-top: 40px;
		text-align:center;
		max-width: 75%;
	}
	.options{
		display: flex;
		justify-content:center;
		border-bottom: 1px solid grey;
		border-top: 1px solid grey;
	}
	.option{
		flex: 1;
		padding:10px 40px 20px 40px;
	}
	.pieces{
		padding:20px;
	}
	.router{
		cursor: pointer;
		text-decoration: underline;
		font-weight: 700;
	}
	.page{
		display:flex;
		flex-flow:column wrap;
		background-color: #ffffffdd;
		align-items:center;
		justify-content:center;
		padding:40px 0px 40px 0px;
	}
.form_command{
	display:flex;
	flex-direction: column;
	align-items:center;
	justify-content:center;
}
.inputs{
	display: flex;
	justify-content:flex-start;
	align-items:flex-start;
}
.inputs1, .inputs2{
	padding-top:10px;
	display:flex;
	align-items:center;
	justify-content:center;
	flex-wrap:wrap;
	flex-direction: column;
	margin-left: 25px;
	margin-right: 25px;
}
.input{
	padding-top: 10px;
	padding-bottom:10px;
	margin-left: -10px;
	width:300px;
}

.simu-input {
    text-align: left;
    background-color: #FFFFFF;
	border: 1px solid #b1bcc4;
	border-radius: 4px;
	color: #565656;
	height: 38px;
	width:100%;
	box-shadow: none;
	padding-left:10px;
	padding-right: 5px;
	margin-top:5px;
}
.simu-input:disabled{
	background-color:#b2bec3;
}
.error_input{
	/*background-color: #fab1a0;*/
	border-bottom:6px solid red;

}
.error_txt{
	margin: 0px;
    font-weight:400;
    overflow:auto;
    font-size:1em;
    font-style: italic;
}
.btn_command{
	margin-top: 20px;
}
.btn_command_div{
	display: flex;
	align-items: center;
	justify-content:center;
}

@media all and (max-width: 1200px) {
	.options{flex-direction: column;}
	.option{padding:10px;}
}

</style>


// WEBPACK FOOTER //
// src/components/Go/Suivi.vue